import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { fetchUnitConstants } from "../../../store/inventories/api";
import UnitError from "./UnitError";
import ConversionError from "./ConversionError";
import LacksRefereceError from "./LacksRefereceError";
import PropTypes from "prop-types";
import { MODAL_REPROCESS_ERRORS } from "./text";
import { UNIT_ERROR } from "./text";

const ModalReprocessPrice = ({ onSubmit, selectedOffer, closeModal, isModalOpen }) => {
  const [instructions, setInstructions] = useState("Loading..");
  const [title, setTitle] = useState("Loading..");
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const [helperMessage, setHelperMessage] = useState(null);
  const [formCompleted, setFormCompleted] = useState(false);
  const [fields, setFields] = useState(null);
  const [baseUnits, setBaseUnits] = useState(null);

  const [selectedItem, setSelectedItem] = useState(null);
  const [isPerLb, setOfferItemPerLb] = useState(false);
  const [selectedConversionFactor, setSelectedConversionFactor] = useState(null);
  const [selectedDefaultUnit, setSelectedDefaultUnit] = useState(null);

  useEffect(() => {
    if (!baseUnits) {
      setInstructions("Loading..");
      setFields(null);
    } else {
      switch (selectedOffer.error) {
        case 0:
          setInstructions(MODAL_REPROCESS_ERRORS.UNIT_ERROR.INSTRUCTIONS);
          setTitle(MODAL_REPROCESS_ERRORS.UNIT_ERROR.TITLE);
          setFields(
            <UnitError
              selectedDefaultUnit={selectedDefaultUnit}
              handleChangeDefaultUnit={handleChangeDefaultUnit}
              units={baseUnits}
              handleChangeConversionFactor={handleChangeConversionFactor}
              recoveryData={selectedOffer}
            />
          );
          break;
        case 1:
          setInstructions(MODAL_REPROCESS_ERRORS.CONVERSION_ERROR.INSTRUCTIONS);
          setTitle(MODAL_REPROCESS_ERRORS.CONVERSION_ERROR.TITLE);
          setFields(<ConversionError recoveryData={selectedOffer} handleChangeConversionFactor={handleChangeConversionFactor} />);
          break;
        case 2:
          setInstructions(MODAL_REPROCESS_ERRORS.LACKS_REFERENCE_ERROR.INSTRUCTIONS);
          setTitle(MODAL_REPROCESS_ERRORS.LACKS_REFERENCE_ERROR.TITLE);
          setFields(
            <LacksRefereceError setSelectedItem={(item) => setSelectedItem(item)} setOfferItemPerLb={(checked) => setOfferItemPerLb(checked)} />
          );
          setHelperMessage(
            <spam>
              {MODAL_REPROCESS_ERRORS.LACKS_REFERENCE_ERROR.HELPER_MSG}
              <a href={`${process.env.REACT_APP_BACKEND_HOST}admin/inventory/item/add/`} target="_blank" rel="noopener noreferrer">
                {MODAL_REPROCESS_ERRORS.LACKS_REFERENCE_ERROR.SECOND_HELPER_MSG}
              </a>
              {MODAL_REPROCESS_ERRORS.LACKS_REFERENCE_ERROR.THIRD_HELPER_MSG}
            </spam>
          );
          break;
        default:
          setInstructions(MODAL_REPROCESS_ERRORS.DEFAULT_ERROR.INSTRUCTIONS);
          setTitle(MODAL_REPROCESS_ERRORS.DEFAULT_ERROR.TITLE);
          setShowSubmitButton(false);
      }
    }
  }, [baseUnits]);

  useEffect(() => {
    fetchUnitConstants().then((res) => {
      setBaseUnits(res.data);
    });
  }, []);

  useEffect(() => {
    setFormCompleted(
      (selectedOffer.error === 0 && selectedDefaultUnit && selectedDefaultUnit !== "-1" && selectedConversionFactor) ||
        (selectedOffer.error === 1 && selectedConversionFactor && !isNaN(selectedConversionFactor)) ||
        (selectedOffer.error === 2 && selectedItem)
    );
  }, [selectedItem, selectedConversionFactor, selectedDefaultUnit]);

  const handleChangeConversionFactor = (event) => {
    const inverse = event.target.innerText != 0 ? 1 / event.target.innerText : "";
    if (isNaN(inverse)) {
      setHelperMessage(<spam>{MODAL_REPROCESS_ERRORS.WARNING}</spam>);
    } else {
      setHelperMessage(null);
    }

    const oppositeId = event.target.id === "first input" ? "second input" : "first input";
    document.getElementById(oppositeId).innerText = inverse;
    setSelectedConversionFactor(event.target.id === "first input" ? event.target.innerText : inverse);
  };

  const handleChangeDefaultUnit = (event) => {
    setSelectedDefaultUnit(event.target.value);
  };

  return (
    <Modal
      isOpen={isModalOpen}
      toggle={closeModal}
      size="lg"
      style={{ maxWidth: "900px", width: "100%" }}
      className={"modal-warning modal-logut"}
    >
      <ModalHeader toggle={closeModal}>{title}</ModalHeader>
      <ModalBody>
        <span>{instructions}</span>
        <div style={{ marginTop: "10px", border: "1px solid #e9ebec", backgroundColor: "#f3f3f3", overflowX: "scroll" }}>
          <table className="table table-striped table-bordered datatable mb-0">
            <thead>
              <tr>
                {Object.keys(selectedOffer.raw_offer_data).map((key) => (
                  <th>{key}</th>
                ))}
              </tr>
            </thead>
            {Object.values(selectedOffer.raw_offer_data).map((data) => (
              <td>{data}</td>
            ))}
          </table>
        </div>
        {fields}
        {helperMessage && <span>{helperMessage}</span>}
      </ModalBody>
      <ModalFooter>
        {showSubmitButton && (
          <Button
            color="primary"
            disabled={!formCompleted}
            onClick={() =>
              onSubmit({
                itemId: selectedItem ? selectedItem.value : undefined,
                isPerLb: isPerLb,
                errorId: selectedOffer.id,
                offerListId: selectedOffer.offer_list,
                conversionFactor: selectedConversionFactor ? selectedConversionFactor : undefined,
                defaultUnit: selectedDefaultUnit ? selectedDefaultUnit : undefined,
              })
            }
          >
            Submit
          </Button>
        )}
        <Button color="secondary" onClick={closeModal}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ModalReprocessPrice.propTypes = {
  onSubmit: PropTypes.func,
  closeModal: PropTypes.func,
  isModalOpen: PropTypes.func,
};

export default ModalReprocessPrice;
